import { render, staticRenderFns } from "./BlockLocation.vue?vue&type=template&id=58969954&"
import script from "./BlockLocation.vue?vue&type=script&lang=js&"
export * from "./BlockLocation.vue?vue&type=script&lang=js&"
import style0 from "./BlockLocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports